import React, { Component } from 'react'
import './styles.scss'
import PropTypes from 'prop-types'
class Bar extends Component {
  constructor (props) {
    super(props)
    this.state = {
      deg: 0,
      value: 0
    }
  }
  componentDidMount () {
  }
  componentDidUpdate (prevProps) {
    if (this.props.value !== prevProps.value) {
      let app = this
      app.setState({
        value: app.props.value
      })
    }
  }
  render () {
    return (
      <div>
        <div className={'Bar Bar-' + this.props.index} style={{ height: this.state.value + '%' }}>
          <div className="Bar_Inner"></div>
          <div className="Bar_Label_Top">{this.state.value ? this.state.value + ' %' : '%'}</div>
          <div className="Bar_Label_Bottom">{this.props.label}</div>
        </div>
      </div>
    )
  }
}
Bar.propTypes = {
  index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  value: PropTypes.any.isRequired,
  label: PropTypes.string.isRequired
}
export default Bar
